import { useState } from "react";
import { Close, Pack } from "../../components/icons/Icon";
import { CloseIcon } from "../../components/icons/Icon2";
import Button from "../../components/updatedComponents/Dealers/Button";
import CheckBox from "../../components/updatedComponents/FormComponents/CheckBox";
import FileUpload from "../../components/updatedComponents/OrderManager/FileUpload";
import styles from "../dashboard/Dispatch.module.css";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { handleFileData } from "../../APIsControll/apiControl2";

const PackOrderModal = ({
  mode,
  closeModal,
  managerId,
  orderId,
  getData,
  warehousename,
  warehouseId,
  isSuperAdmin,
}) => {
  const { show } = useToast();
  const [noOfPacks, setNoOfPacks] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const updateImageAtIndex = (index, newImage) => {
    setImages((prev) => {
      const updated = [...prev];
      updated[index] = newImage;
      return updated;
    });
  };

  const PackOrder = async () => {
    if (images.length === 0) {
      show("Please upload at least one image.", "warning");
      return;
    }

    if (noOfPacks === "") {
      show("Number of packs cannot be empty.", "warning");
      return;
    }

    if (isChecked) {
      const numPacks = parseInt(noOfPacks);
      if (isNaN(numPacks) || numPacks <= 0) {
        show("Please enter a valid number of packs.", "warning");
        return;
      }

      if (images.length < numPacks) {
        show(
          `You must upload at least ${numPacks} images for ${numPacks} packs.`,
          "warning"
        );
        return;
      }
    }

    const formData = new FormData();

    formData.append("warehousename", isSuperAdmin ? warehousename : "");
    formData.append("warehouseId", isSuperAdmin ? warehouseId : "");
    formData.append("packingQty", noOfPacks);
    images.forEach((image) => formData.append("images", image));

    try {
      setLoading(true);
      const res = await handleFileData(
        `packing/orderPacked/${managerId}/${orderId}`,
        formData
      );

      if (res.status === "success") {
        setLoading(false);
        show(res.msg, "success");
        getData();
        closeModal();
      }

      if (res.status === "failed") {
        setLoading(false);
        show(res.msg, "error");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div
      className={styles.pack_order_modal}
      style={{ backgroundColor: mode && "#232529" }}
    >
      <div className={styles.header}>
        <p style={{ color: mode && "#FFFFFF" }}>Pack Order</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div className={styles.no_of_packs}>
        <p style={{ color: mode && "#FFFFFF" }}>Enter number of pack(s):</p>
        <input
          type="number"
          max={999}
          onInput={(e) => {
            if (e.target.value.length > 3) {
              e.target.value = e.target.value.slice(0, 3);
            }
          }}
          style={{
            backgroundColor: mode && "#1B1D21",
            borderColor: mode && "#1B1D21",
            color: mode && "#9F9F9F",
          }}
          value={noOfPacks}
          onChange={(e) => setNoOfPacks(e.target.value)}
        />
      </div>

      <div className={styles.add_img}>
        <p style={{ color: mode && "#FFFFFF" }}>Add image for every pack:</p>
        <CheckBox
          checked={isChecked}
          handleChange={() => setIsChecked(!isChecked)}
        />
      </div>

      <div className={styles.media_con}>
        <div>
          <FileUpload
            key={0}
            mode={mode}
            image={images[0]}
            setImage={(img) => updateImageAtIndex(0, img)}
          />
        </div>

        {isChecked &&
          [...Array(Math.max(Number(noOfPacks) - 1, 0)).keys()].map((i) => (
            <div>
              <FileUpload
                key={i + 1}
                mode={mode}
                image={images[i + 1]}
                setImage={(img) => updateImageAtIndex(i + 1, img)}
              />
            </div>
          ))}
      </div>

      <div style={{ flex: "1" }}></div>

      <div className={styles.bottom_btns}>
        <Button
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Close"}
          buttonIcon={<Close />}
          buttonClick={closeModal}
        />
        <Button
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Pack"}
          buttonIcon={<Pack />}
          buttonClick={PackOrder}
          loading={loading}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default PackOrderModal;
